import { useEffect, useCallback } from "react";

type KeyboardEventKey = KeyboardEvent["key"];

const useKeyboardShortcut = (
  key: KeyboardEventKey,
  callback: () => void,
  preventDefault: boolean = true
): void => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === key) {
        if (preventDefault) {
          event.preventDefault();
        }
        callback();
      }
    },
    [key, callback, preventDefault]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
};

export default useKeyboardShortcut;
